import { Component, Output, EventEmitter, HostListener, Input } from '@angular/core';

import { CheckBoxState, GroupedCheckboxSelections } from '../../../enclosure/models/product-accessories.model';

@Component({
    selector: 'app-bom-select-dropdown',
    templateUrl: './bom-select-dropdown.component.html',
    styleUrls: ['./bom-select-dropdown.component.scss'],
    standalone: false
})
export class BomSelectDropdownComponent {

  isOpenedBOMSelect = false;
  groupedCheckboxSelections = GroupedCheckboxSelections;
  CheckBoxStates = CheckBoxState;

  @Input() checkBoxState: CheckBoxState;
  @Input() isDocumentsPage: boolean;
  @Input() isProjectDocumentsPage = false;
  @Input() documentsApartmentSpecificSelected: boolean;
  @Input() documentsEnclosureSelected: boolean;
  @Input() bomDirectFilterSelected: boolean;
  @Input() bomPrewiringFilterSelected: boolean;

  @Output() optionSelected = new EventEmitter<string>();

  @HostListener('document:click')
  onClick() {
    if (this.isOpenedBOMSelect === true) {
      this.isOpenedBOMSelect = false;
    }
  }

  selectOption(option: string) {
    this.optionSelected.emit(option);
    this.changeArrowDirection();
  }

  changeArrowDirection() {
    this.isOpenedBOMSelect = !this.isOpenedBOMSelect;
  }

}
